import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.transferLocal;
const getResAccountDetail = (state: AppState) => state.transferLocal.accountCredit;
const getResAccountByPhone = (state: AppState) => state.transferLocal.accountByPhone;
const getResponseMakeFee = (state: AppState) => state.transferLocal.responseMakeFee;
const getDataCreate = (state: AppState) => state.transferLocal.dataCreate;
const getResponseCreated = (state: AppState) => state.transferLocal.responseCreate;
const getResponseConfirm = (state: AppState) => state.transferLocal.responseConfirm;
const getResponseAuth = (state: AppState) => state.transferLocal.responseAuth;

export const getTransferLocalStoreSelector = createSelector(getStore, (data) => data);
export const getTransferLocalResAccountDetailSelector = createSelector(getResAccountDetail, (account) => account);
export const getTransferLocalAccountByPhoneSelector = createSelector(getResAccountByPhone, (account) => account);
export const getTransferLocalDataCreateSelector = createSelector(getDataCreate, (data) => data);
export const getTransferLocalMakeFeeSelector = createSelector(getResponseMakeFee, (fee) => fee);

export const getTransferLocalResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTransferLocalResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);
export const getTransferLocalResponseAuthSelector = createSelector(getResponseAuth, (res) => res);
